import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 3],
        rowsSize: [1, 2],
        gap: "24px",
        components: [
          [],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/info-icon.svg`,
                    styles: {
                      width: "32px",
                      height: "32px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "The hearing models from the Auditory Modelling Toolbox (AMT) replicate different functions of the human auditory system, such as sound source localization. Baumgartner’s model for saggital plane localization is based on the extraction of directional components from a target input (i.e. HRTF) and compares the extracted features with a set of templates.",
                    scrollbars: false,
                    styles: {
                      textAlign: "left",
                      width: "370px",
                      height: "200px",
                      padding: 0,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
